/*
 * Copyright (c) Flowmap.gl contributors
 * Copyright (c) 2018-2020 Teralytics
 * SPDX-License-Identifier: Apache-2.0
 */
export default `\
#define SHADER_NAME flow-circles-layer-fragment-shader
#define SOFT_OUTLINE 0.05
#define EPS 0.05
precision highp float;

uniform vec4 emptyColor;
uniform float outlineEmptyMix;

varying vec4 vColor;
varying vec2 unitPosition;
varying float unitInRadius;
varying float unitOutRadius;

float when_gt(float x, float y) {
  return max(sign(x - y), 0.0);
}

void main(void) {
  geometry.uv = unitPosition;
  float distToCenter = length(unitPosition);
  if (distToCenter > 1.0) {
    discard;
  }

  // See https://stackoverflow.com/questions/47285778
  vec4 ringColor = mix(
    emptyColor / 255., vColor,
    when_gt(unitInRadius, unitOutRadius)
  );
  vec4 outlineColor = mix(
    mix(vColor, emptyColor / 255., outlineEmptyMix),
    vColor,
    when_gt(unitInRadius, unitOutRadius)
  );
  
  float innerR = min(unitInRadius, unitOutRadius) * (1.0 - SOFT_OUTLINE);
  
  // Inner circle
  float step2 = innerR - 2.0 * EPS; 
  float step3 = innerR - EPS;
  
  // Ring
  float step4 = innerR;
  // float step5 = 1.0 - SOFT_OUTLINE - EPS;
  // float step6 = 1.0 - SOFT_OUTLINE;
  float step5 = 1.0 - 5.0 * EPS;
  float step6 = 1.0;
  
  gl_FragColor = vColor;
  gl_FragColor = mix(gl_FragColor, emptyColor / 255., smoothstep(step2, step3, distToCenter));
  gl_FragColor = mix(gl_FragColor, ringColor, smoothstep(step3, step4, distToCenter));
  gl_FragColor = mix(gl_FragColor, outlineColor, smoothstep(step5, step6, distToCenter));
  // gl_FragColor = mix(gl_FragColor, emptyColor / 255., smoothstep(step6, 1.0, distToCenter));
  gl_FragColor.a = vColor.a;
  gl_FragColor.a *= smoothstep(0.0, SOFT_OUTLINE, 1.0 - distToCenter);
  DECKGL_FILTER_COLOR(gl_FragColor, geometry);
}
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmxvd0NpcmNsZXNMYXllckZyYWdtZW50Lmdsc2wuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvRmxvd0NpcmNsZXNMYXllci9GbG93Q2lyY2xlc0xheWVyRnJhZ21lbnQuZ2xzbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7OztHQUlHO0FBQ0gsZUFBZTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQTBEZCxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiLypcbiAqIENvcHlyaWdodCAoYykgRmxvd21hcC5nbCBjb250cmlidXRvcnNcbiAqIENvcHlyaWdodCAoYykgMjAxOC0yMDIwIFRlcmFseXRpY3NcbiAqIFNQRFgtTGljZW5zZS1JZGVudGlmaWVyOiBBcGFjaGUtMi4wXG4gKi9cbmV4cG9ydCBkZWZhdWx0IGBcXFxuI2RlZmluZSBTSEFERVJfTkFNRSBmbG93LWNpcmNsZXMtbGF5ZXItZnJhZ21lbnQtc2hhZGVyXG4jZGVmaW5lIFNPRlRfT1VUTElORSAwLjA1XG4jZGVmaW5lIEVQUyAwLjA1XG5wcmVjaXNpb24gaGlnaHAgZmxvYXQ7XG5cbnVuaWZvcm0gdmVjNCBlbXB0eUNvbG9yO1xudW5pZm9ybSBmbG9hdCBvdXRsaW5lRW1wdHlNaXg7XG5cbnZhcnlpbmcgdmVjNCB2Q29sb3I7XG52YXJ5aW5nIHZlYzIgdW5pdFBvc2l0aW9uO1xudmFyeWluZyBmbG9hdCB1bml0SW5SYWRpdXM7XG52YXJ5aW5nIGZsb2F0IHVuaXRPdXRSYWRpdXM7XG5cbmZsb2F0IHdoZW5fZ3QoZmxvYXQgeCwgZmxvYXQgeSkge1xuICByZXR1cm4gbWF4KHNpZ24oeCAtIHkpLCAwLjApO1xufVxuXG52b2lkIG1haW4odm9pZCkge1xuICBnZW9tZXRyeS51diA9IHVuaXRQb3NpdGlvbjtcbiAgZmxvYXQgZGlzdFRvQ2VudGVyID0gbGVuZ3RoKHVuaXRQb3NpdGlvbik7XG4gIGlmIChkaXN0VG9DZW50ZXIgPiAxLjApIHtcbiAgICBkaXNjYXJkO1xuICB9XG5cbiAgLy8gU2VlIGh0dHBzOi8vc3RhY2tvdmVyZmxvdy5jb20vcXVlc3Rpb25zLzQ3Mjg1Nzc4XG4gIHZlYzQgcmluZ0NvbG9yID0gbWl4KFxuICAgIGVtcHR5Q29sb3IgLyAyNTUuLCB2Q29sb3IsXG4gICAgd2hlbl9ndCh1bml0SW5SYWRpdXMsIHVuaXRPdXRSYWRpdXMpXG4gICk7XG4gIHZlYzQgb3V0bGluZUNvbG9yID0gbWl4KFxuICAgIG1peCh2Q29sb3IsIGVtcHR5Q29sb3IgLyAyNTUuLCBvdXRsaW5lRW1wdHlNaXgpLFxuICAgIHZDb2xvcixcbiAgICB3aGVuX2d0KHVuaXRJblJhZGl1cywgdW5pdE91dFJhZGl1cylcbiAgKTtcbiAgXG4gIGZsb2F0IGlubmVyUiA9IG1pbih1bml0SW5SYWRpdXMsIHVuaXRPdXRSYWRpdXMpICogKDEuMCAtIFNPRlRfT1VUTElORSk7XG4gIFxuICAvLyBJbm5lciBjaXJjbGVcbiAgZmxvYXQgc3RlcDIgPSBpbm5lclIgLSAyLjAgKiBFUFM7IFxuICBmbG9hdCBzdGVwMyA9IGlubmVyUiAtIEVQUztcbiAgXG4gIC8vIFJpbmdcbiAgZmxvYXQgc3RlcDQgPSBpbm5lclI7XG4gIC8vIGZsb2F0IHN0ZXA1ID0gMS4wIC0gU09GVF9PVVRMSU5FIC0gRVBTO1xuICAvLyBmbG9hdCBzdGVwNiA9IDEuMCAtIFNPRlRfT1VUTElORTtcbiAgZmxvYXQgc3RlcDUgPSAxLjAgLSA1LjAgKiBFUFM7XG4gIGZsb2F0IHN0ZXA2ID0gMS4wO1xuICBcbiAgZ2xfRnJhZ0NvbG9yID0gdkNvbG9yO1xuICBnbF9GcmFnQ29sb3IgPSBtaXgoZ2xfRnJhZ0NvbG9yLCBlbXB0eUNvbG9yIC8gMjU1Liwgc21vb3Roc3RlcChzdGVwMiwgc3RlcDMsIGRpc3RUb0NlbnRlcikpO1xuICBnbF9GcmFnQ29sb3IgPSBtaXgoZ2xfRnJhZ0NvbG9yLCByaW5nQ29sb3IsIHNtb290aHN0ZXAoc3RlcDMsIHN0ZXA0LCBkaXN0VG9DZW50ZXIpKTtcbiAgZ2xfRnJhZ0NvbG9yID0gbWl4KGdsX0ZyYWdDb2xvciwgb3V0bGluZUNvbG9yLCBzbW9vdGhzdGVwKHN0ZXA1LCBzdGVwNiwgZGlzdFRvQ2VudGVyKSk7XG4gIC8vIGdsX0ZyYWdDb2xvciA9IG1peChnbF9GcmFnQ29sb3IsIGVtcHR5Q29sb3IgLyAyNTUuLCBzbW9vdGhzdGVwKHN0ZXA2LCAxLjAsIGRpc3RUb0NlbnRlcikpO1xuICBnbF9GcmFnQ29sb3IuYSA9IHZDb2xvci5hO1xuICBnbF9GcmFnQ29sb3IuYSAqPSBzbW9vdGhzdGVwKDAuMCwgU09GVF9PVVRMSU5FLCAxLjAgLSBkaXN0VG9DZW50ZXIpO1xuICBERUNLR0xfRklMVEVSX0NPTE9SKGdsX0ZyYWdDb2xvciwgZ2VvbWV0cnkpO1xufVxuYDtcbiJdfQ==